import { usePersistentState } from "../../hooks/usePersistentState";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HotelContext } from "../../context/hotel";
import { useContext } from "react";
const PublicLastRequest = () => {
    const navigate = useNavigate();
    const { data: hotel } = useContext(HotelContext);
    const [lastRequest, setLastRequest] = usePersistentState(`last-request-payment-id`, null, 72000)
    useEffect(() => {
        if (lastRequest) {
            navigate(`/${hotel?.code}/public/requests/${lastRequest}`);
        }else{
            navigate(`/${hotel?.code}/public`);
        }
    }, [lastRequest])
    return null;
}

export default PublicLastRequest;